// Rollen ohne Web-Zugang weist das Backend mit 403 { error: "app_only" } ab —
// beim Login und, fuer Bestandssessions, auf jedem authentifizierten /api/web/*.
// Dann raeumen wir die gespeicherte Session weg und schicken auf den App-Hinweis.

export const APP_ONLY_PATH = '/app-only';

// Der Wechsel laeuft ueber ein Event statt window.location: Interceptor und
// api.js haben keinen Router-Kontext, und ein harter Seitenwechsel wuerde in
// Produktion am Static-Handler haengenbleiben (der kennt nur gebaute Dateien).
// AuthContext hoert auf das Event und navigiert clientseitig.
export const APP_ONLY_EVENT = 'timetab:app-only';

export function isAppOnlyPayload(payload) {
  return payload?.error === 'app_only';
}

export function clearStoredSession() {
  localStorage.removeItem('session_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('selected_location_id');
}

export function redirectToAppOnly() {
  if (window.location.pathname === APP_ONLY_PATH) return;

  clearStoredSession();
  window.dispatchEvent(new Event(APP_ONLY_EVENT));
}
